<template>
  <div class="login-form" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <div>

      <div class="d-flex justify-between align-center mb-3 flex-wrap">
        <span class="register-heading" :style="getPrimaryColor">
          Forgot Password Verification
        </span>
        <div class="nav-link text-right">
          Already have an account?&nbsp;
          <router-link to="/signin" class="fw-bold" :style="getPrimaryColor">
            Log In
          </router-link>
        </div>
      </div>

      <div class="divider">
        <span class="line"></span>
        <span class="line"></span>
      </div>
      <div class="content">
        <p class="text-muted opacity-80 fs-7">
          Forgot your password? <br /> Enter your email and we’ll send you a reset link.
        </p>
        <div>
          <el-form :model="forgotPasswordData" ref="forgotPassword" class="log-form"
            @keyup.enter.native="submitForm('forgotPassword')" v-if="showForm" autocomplete="off">
            <el-form-item label="Email *" class="mb-1">
              <el-input type="text" placeholder="Enter Email" v-model="forgotPasswordData.email"
                autocomplete="off"></el-input>
              <p class="error" v-if="
                getForgotPasswordVerifyErrors &&
                getForgotPasswordVerifyErrors.email
              ">
                {{ getForgotPasswordVerifyErrors.email }}
              </p>
            </el-form-item>
            <el-form-item label="Password *" class="mb-1" prop="password">
              <el-input :type="passwordType" placeholder="Enter Password" v-model="forgotPasswordData.password"
                autocomplete="off" @change="checkPassword">
                <template #suffix>
                  <span class="password-toggle" :style="getPrimaryColor"
                    @click="passwordType = passwordType === 'password' ? 'text' : 'password'"
                    style="cursor: pointer; user-select: none; font-size: 12px; color: #409EFF;">
                    {{ passwordType === 'password' ? 'SHOW' : 'HIDE' }}
                  </span>
                </template>
              </el-input>

              <p class="error" v-if="getForgotPasswordVerifyErrors && getForgotPasswordVerifyErrors.password">
                {{ getForgotPasswordVerifyErrors.password }}
              </p>
            </el-form-item>
            <span class="error" v-for="(err, index) in passwordError" :key="index">
              {{ err }}<br />
            </span>
            <el-form-item label="Verification Code *" class="mb-1">
              <el-input type="text" placeholder="Enter Verification Code" v-model="forgotPasswordData.verification_code"
                autocomplete="off"></el-input>
              <p class="error" v-if="
                getForgotPasswordVerifyErrors &&
                getForgotPasswordVerifyErrors.verification_code
              ">
                {{ getForgotPasswordVerifyErrors.verification_code }}
              </p>
            </el-form-item>
            <el-form-item class="mt-4">
              <el-button type="primary"  size="medium"  round class="type-2 w-100 fs-6" @click="submitForm('forgotPassword')"
                :loading="submitLoading" :style="getButtonStyles" >Reset Password</el-button>
              <p class="error" v-if="
                getForgotPasswordVerifyErrors &&
                getForgotPasswordVerifyErrors.critical_error
              ">
                {{ getForgotPasswordVerifyErrors.critical_error }}
              </p>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { mapGetters } from "vuex";

import CustomizationLayer from "@/mixins/CustomizationLayer";
export default {
  name: "ForgotPasswordVerification",
    mixins: [CustomizationLayer],
  data() {
    return {
      passwordType: "password",
      submitLoading: false,
      showForm: true,
      passwordError: [],
      errorView: false,
      forgotPasswordData: {
        email: "",
        verification_code: "",
        password: "",
      },
      password_rules: [
        { message: "One Lowercase Letter Required.", regex: /[a-z]+/ },
        { message: "One Uppercase Letter Required.", regex: /[A-Z]+/ },
        { message: "8 Characters Minimum.", regex: /.{6,}/ },
        { message: "One Number Required.", regex: /[0-9]+/ },
        { message: "One Special Character Required", regex: /[!@#$%^&*]/ },
      ],
      rules: {
        password: [
          {
            required: true,
            message: "Password is required",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.$store.dispatch("auth/reset");
    this.forgotPasswordData.verification_code = this.$route.query.vc;
    this.forgotPasswordData.email = this.$route.query.email;
  },
  computed: {
    ...mapGetters("auth", [
      "getForgotPasswordVerifyStatus",
      "getForgotPasswordVerifyErrors",
    ])
  },
  created() {
    this.$store.commit("errors/setErrors", null, { root: true });
  },
  methods: {
    checkPassword() {
      this.passwordError = [];
      this.password_rules.forEach((rule) => {
        if (!rule.regex.test(this.forgotPasswordData.password)) {
          this.passwordError.push(rule.message);
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.passwordError.length) {
            this.resetPassword();
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    async resetPassword() {
      try {
        this.submitLoading = true;
        this.forgotPasswordData.email =
          this.forgotPasswordData.email.toLowerCase();
        await this.$store.dispatch(
          "auth/forgotPasswordVerify",
          this.forgotPasswordData
        );

        if (this.getForgotPasswordVerifyStatus) {
          this.$notify.success({
            title: "Success",
            message: `Reset password successfully`,
          });

          this.$router.push({ path: "/signin" });
        }
        this.submitLoading = false;
      } catch (err) {
        this.submitLoading = false;
        console.log("resetPassword", err);
      }
    },
  },
};
</script>

<style lang="scss">
.swal2-icon {
  .swal2-info {
    border-color: #f754a2 !important;
    color: #f754a2 !important;
  }
}

.swal2-styled {
  .swal2-confirm {
    background-color: #f754a2 !important;
  }
}

.has-error {
  border-color: red;
}

a {
  text-decoration: none !important;
  color: #196392 !important;
}

a:hover {
  text-decoration: underline !important;
  /* Optional: underline on hover */
  color: #196392 !important;
}



/* Divider with lines and 'OR' in the middle */
.divider {
  display: flex;
  align-items: center;
  width: 100%;
  text-align: center;
  /* margin: 0 20px; */
}

.line {
  flex: 1;
  border-top: 1px solid #ddd;
  /* light gray line */
}

.divider-text {
  margin: 0 10px;
  color: #aaa;
  font-size: 16px;
  font-weight: bold;
}

/* Flex container for title and link */
.login-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.login-title {
  font-size: 24px;
  margin: 0;
}

.password-toggle {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #409eff;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  user-select: none;
}

.login-form {
  border: 1px solid #cfcfcf;
  border-radius: 2em;
  width: 100%;
  max-width: 550px;
  padding: 2rem;
  background: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
}

.login-form h2 {
  margin-bottom: 1.5rem;
  color: #333;
  text-align: center;
}

.login-form input {
  width: 100%;
  padding: 0.75rem;
  margin-bottom: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

/* FULL RESPONSIVE FOR MOBILE & TABLET */
@media (max-width: 1024px) {

  .login-form {
    border: 1px solid #cfcfcf;
    border-radius: 2em;
    // max-width: 100%;
    padding: 1.5rem;
    margin: 0 auto;
    box-shadow: none;
    /* border-radius: 0; */
  }

  .login-form h2 {
    font-size: 1.5rem;
  }

  .password-toggle {
    right: 10px;
    font-size: 12px;
  }
}

.el-form-item {
  margin-bottom: 8px !important;
}

.d-flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.align-center {
  align-items: center;
}

.flex-wrap {
  flex-wrap: wrap;
}

.mb-3 {
  margin-bottom: 1rem;
  /* adjust as needed */
}

.m-0 {
  margin: 0;
}

.register-heading {
  font-size: 1.25rem;
  /* Larger text, you can go up to 1.5rem if needed */
  font-weight: 600;
  /* Semi-bold */
  color: #196392;
  /* Bootstrap's text-dark */
  padding-bottom: 0.5rem;
  margin: 0;
  display: inline-block;
}
</style>
